<div *ngIf="details.length === 0">
  <div class="col-4 offset-4 marTB8 noData">
    <h5 class="H5Header marL16 marT32 center">
      <strong name="nodata">No data available</strong>
    </h5>
  </div>
</div>
<mat-tab-group (selectedTabChange)="onTabChanged($event)" *ngIf="details?.length" class="matTabsContainer">
  <mat-tab *ngFor="let detail of details" [label]="detail.id">
    <ng-template mat-tab-label style="display: block">
      <app-donut-chart [chartData]="detail" class="marB8"> </app-donut-chart>
    </ng-template>
    <div *ngIf="detail.tableDataObj === null">
      <div class="col-4 offset-4 marTB8">
        <h5 class="H5Header marL16 marT32 center">
          <strong name="nodata">No data available</strong>
        </h5>
      </div>
    </div>

    <div *ngIf="detail.tableDataObj !== null">
      <app-mat-table-with-chip
        [tableData]="detail.tableDataObj"
        [source]="source"
        (dataToParent)="getCandidateID($event)"
      ></app-mat-table-with-chip>
    </div>
  </mat-tab>
</mat-tab-group>
